import { render, staticRenderFns } from "./wapHeader.vue?vue&type=template&id=13a3ceb9&scoped=true"
import script from "./wapHeader.vue?vue&type=script&lang=js"
export * from "./wapHeader.vue?vue&type=script&lang=js"
import style0 from "./wapHeader.vue?vue&type=style&index=0&id=13a3ceb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3ceb9",
  null
  
)

export default component.exports